import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	issueTypeFilterErrorFlagTitle: {
		id: 'software-deployments.top-filters.issue-type-filter.issue-type-filter-error-flag-title',
		defaultMessage: 'Unable to load issue type filter.',
		description: 'Error flag title when displaying issue type filter fails',
	},
	issueTypeFilterErrorFlagDescription: {
		id: 'software-deployments.top-filters.issue-type-filter.issue-type-filter-error-flag-description',
		defaultMessage: 'Please try to refresh the page again.',
		description: 'Error flag description when displaying issue type filter fails',
	},
});
